export const environment = {
  production: false,
  apiUrl: 'https://development-api.thehuro.com',
  environmentName: 'development',
  portal: 'contractor',
  firebase: {
    apiKey: 'AIzaSyCzV0Pb9GO0Uf6Fq_CS4uRahdZmqnulFBE',
    authDomain: 'huro-d34f3.firebaseapp.com',
    projectId: 'huro-d34f3',
    storageBucket: 'huro-d34f3.firebasestorage.app',
    messagingSenderId: '862352066177',
    appId: '1:862352066177:web:07100f708b854dfd14ef80'
  },
  firebaseVapidKey:
    'BK5g4b9MNJR3iAt5iSixuMlEMHe0JMpD0RPTI-MIGJKHOmjhO-NJRqUVukuvA7R8ndJwPYP1b8_VUuQNBej5Bqc',
  // TODO: replace placeholder with the actual Stripe test-mode publishable key
  // before enabling the upfront payment flow.
  stripePublishableKey:
    'pk_test_51T0QbUDWOyJZsahHyP2M4hcbJb0xtVoDc8V2qkwy6w8hRlc1865ASrC7AH7DUBqtkItTIk4m7eSKh1tjhBjeDcMK001JkcaJGW'
};
